import { render, staticRenderFns } from "./AccountSettingsWidget.vue?vue&type=template&id=3c7e554e&scoped=true"
import script from "./AccountSettingsWidget.vue?vue&type=script&lang=js"
export * from "./AccountSettingsWidget.vue?vue&type=script&lang=js"
import style0 from "./AccountSettingsWidget.vue?vue&type=style&index=0&id=3c7e554e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7e554e",
  null
  
)

export default component.exports